import React from 'react'

import styles from './styles.module.scss'

const AdvertisementLabel = () => {
  return <span className={`${styles.advertisementLabel} note-sponsored`}>Ad</span>
}

export default AdvertisementLabel
